import { ACCOUNTS_WITH_MCC_CODE_DISCOUNTS_ONLY } from '../env';
import { Discount } from '../types/discounts';

export const checkIsMccOnly = (accountId: string) => {
    // Check if merchant is using the discount service wit mcc codes only. If true, we limit the discount forms
    // so that only compatible discounts can be created, and change the select store/saleslocations component
    // to accept Mcc codes or Mcc ranges.
    // As of the time this is implemented only Instabank is using the Mcc discounts.

    // TODO: read mcc only param from SSM
    const stripped = accountId.startsWith('T') || accountId.startsWith('P') ? accountId.substr(1) : accountId;
    return ACCOUNTS_WITH_MCC_CODE_DISCOUNTS_ONLY.includes(stripped);
};

// https://github.com/Dintero/backoffice/pull/2263#issuecomment-1243731818
export const getStoreIds = (discount?: Discount) => discount ? (discount.requirement.store?.id && discount.requirement.store.id) ?? discount.requirement.store_ids : undefined;
